module.exports = new __parcel__URL__("arrow-up.87a69047.svg").toString();